<template>
  <section>
    <section class="grid-flex column margin-top-s">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex">
          <tabs :data="reportTabs" v-model="currentTab"></tabs>
        </div>
      </div>
    </section>

    <tax-tracker v-if="currentTab === 'tax-tracker'"></tax-tracker>
    <!-- encurtador de link -->
    <page-ignore v-if="currentTab === 'page-ignore'"></page-ignore>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";

import TaxTracker from "@/modules/trackingV2/TaxTracker";
import PageIgnore from "@/modules/trackingV2/PageIgnore";

export default {
  name: "dash-tax-tracker",
  components: {
    Tabs,
    TaxTracker,
    PageIgnore
  },
  props: [],
  data() {
    return {
      loading: false,
      currentTab: "tax-tracker",
      reportTabs: [
        {
          name: "tax-tracker",
          title: "Taxa de Tracker",
        },
        {
          name: "page-ignore",
          title: "Páginas Ignoradas",
        },
      ],
    };
  },
  mounted() {
  },
  watch: {
    currentTab() {
      if (this.slug === this.currentTab) {
        return
      }
      //this.$router.push({ name: "Track", params: { slug: this.currentTab } });
    }
  }

};
</script>

<style lang="scss" scoped></style>
